export const includeKioskOptions: { label: string; value: number }[] = [
  { label: 'Yes', value: 1 },
  { label: 'No', value: 0 }
];
